// Constants for different requests for current reducer
export default {
  siteInfoTasks: 'SITE_INFO_TASKS',
};
